import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=5a05bd1f&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a05bd1f",
  null
  
)

export default component.exports